(function () {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    /**
     * A controller for the reset password dialog.
     */
    angular
        .module('ihh-common-web')
        .controller('ResetPasswordCtrl', ResetPasswordCtrl);

    ResetPasswordCtrl.$inject = ['$scope', '$modalInstance', 'RestResources', 'MemorySvc', 'UserSvc', 'Utilities', 'emailAddress', 'app'];

    function ResetPasswordCtrl($scope, $modalInstance, RestResources, MemorySvc, UserSvc, Utilities, emailAddress, app) {

        $scope.getCommonHost = function() {
            return RestResources.getCommonHost();
        };

        $scope.passwordResetRequest = {};
        $scope.passwordResetRequest.app = app;
        $scope.passwordResetRequest.emailAddress = emailAddress;

        $scope.isResetFormAcceptable = function() {
            if (angular.isDefined($scope.savePromise) && !$scope.savePromise.$resolved) {
                return false;
            }

            if (angular.isDefined($scope.passwordResetRequest)) {
                var isEmailAddressOfMinimumLength = angular.isDefined($scope.passwordResetRequest.emailAddress) && $scope.passwordResetRequest.emailAddress.length > 0;

                if (isEmailAddressOfMinimumLength) {
                    return true;
                }
            }
            else {
                return false;
            }
        };

        $scope.sendEmail = function() {
            var resource = RestResources.getPasswordResetResource();
            $scope.savePromise = resource.save({}, {
                application: $scope.passwordResetRequest.app,
                email: $scope.passwordResetRequest.emailAddress
            }, function() {
                MemorySvc.memorize(MemorySvc.LOCAL, UserSvc.USERNAME, $scope.passwordResetRequest.emailAddress);
                Utilities.modalWait('An email with instructions to establish a new password has been sent to ' + $scope.passwordResetRequest.emailAddress + '.', 'OK', 'Forgot Your Password');
                $modalInstance.close();
            }, function(err) {
                Utilities.modalWait('Could not send email: ' + RestResources.getErrorMsg(err), 'OK', 'Unable to Reset Password');
            });
        };

        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };
    }
})();